import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyCeg44oL0Ez8I5-bOMBepiNpwctl_NLsdU",
    authDomain: "thai-alert.firebaseapp.com",
    databaseURL: "https://thai-alert-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "thai-alert",
    storageBucket: "thai-alert.firebasestorage.app",
    messagingSenderId: "640512234316",
    appId: "1:640512234316:web:34ab8aa493c8e297a6f5e9"
  };
  
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);

export { auth, database };